export { accountNumberValidation as validateAccountNumber } from './validation/BankAccount/accountNumber';
export { emailValidation as validateEmail } from './validation/email';
export { phoneValidation as validatePhone } from './validation/phone';
export { ssnoValidation as validateSsno } from './validation/ssno';








/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./~/@teamui/validation/index.ts
 **/